import {
  PerspectiveCamera,
  Scene,
  WebGLRenderer,
  DirectionalLight,
  ReinhardToneMapping,
  HemisphereLight,
  CircleGeometry,
  Mesh,
  MeshBasicMaterial,
  DoubleSide,
  PlaneGeometry,
  CineonToneMapping,
  ACESFilmicToneMapping, LinearToneMapping,
} from "three";

import Orbit from "../controls/orbit";
import PointerLock from "../controls/pointerLock";
import {Howl, Howler} from 'howler';
import Audio from '../../../static/audio/audio3.mp3';

import TWEEN from "@tweenjs/tween.js";
import {Reflector} from "three/examples/jsm/objects/Reflector";
import MobileDetect from "mobile-detect";

export default class Viewer {
  constructor(container) {
    this.container = container;
    this.meshOnScene = [];
    this.mobile = false;
    this.interactivePoints = [];
    this.loader = true;
    this.volume = true;
    this.init();
    this.musicIcon = document.getElementById('musicIcon');
    this.volumeOn = document.getElementById('on');
    this.volumeOff = document.getElementById('off');
    this.image = document.getElementById('painting__mobile');
    this.optionWrap = document.getElementById('mainOptWrap');
    this.shareModalWrap = document.getElementById('shareModalWrap');
    this.orientationBlock = document.getElementById('orientationBlock');
    this.main = document.querySelector(".main");
    this.upBtn = document.getElementById('up');
    this.leftBtn = document.getElementById('left');
    this.rightBtn = document.getElementById('right');
    this.downBtn = document.getElementById('down');
    this.mobJoystick = document.getElementById('mobileJoystic');
    this.tutorial = document.getElementById('movementTutorial');
    this.tutorialMob = document.getElementById('movementTutorialMob');
    this.firstLogIn = true;
    this.musIn = false;
    this.tutorialSwitch = true;
    this.firstLoadWrap = document.getElementById('firstLoadWrap');

    document.addEventListener("DOMContentLoaded", () => {
      this.firstLoadWrap.classList.add('none')
      this.initOrientation();
    });
    this.initClickListeners();
    window.onblur = () => {
      Howler.volume(0);
    };
    window.onfocus = () => {
      if (this.volume) {
        Howler.volume(0.3)
      }
    };
    if (this.mobile) {
      document.getElementById('centralBtn').addEventListener('click', () => {
        this.musIn = true;
        document.getElementById('moveBtn').classList.remove('none');
        if (!this.loader) {
          this.mobJoystick.classList.remove('none');
        }
      })
    }
  }
  init() {

    this.sound = new Howl({
      src: Audio,
      // autoplay: true,
      loop: true,
      volume: 0.3,
    });

    // CAMERA
    window.camera = this.camera = new PerspectiveCamera(
      75,
      this.container.offsetWidth / this.container.offsetHeight,
      0.1,
      500
    );
    camera.position.y = 1.7;
    camera.rotateY(1.55);
    camera.rotation.order = 'YXZ';

    // SCENE
    window.scene = this.scene = new Scene();

    this.reflectorGeometry = new CircleGeometry( 40, 64 );
    this.reflectorGroundMirror = new Reflector( this.reflectorGeometry, {
      clipBias: 0.3,
      textureWidth: window.innerWidth * window.devicePixelRatio,
      textureHeight: window.innerHeight * window.devicePixelRatio,
      color: 0x777777,
      // opacity: 0.2,
      // transparent: true,
    } );
    this.reflectorGroundMirror.position.set(-13.5, -0.01, 7.3);
    this.reflectorGroundMirror.rotateX( - Math.PI / 2 );
    this.scene.add( this.reflectorGroundMirror );

    this.windowPlaneMesh = new Mesh(
        new PlaneGeometry(5.8, 2.3),
        new MeshBasicMaterial({color: 'white', side: DoubleSide})
    );
    this.windowPlaneMesh.position.set(5.5, 1.6, 0);
    this.windowPlaneMesh.rotation.y = Math.PI / 2;
    this.windowPlaneMesh.material.visible = false;
    this.meshOnScene.push(this.windowPlaneMesh);
    this.scene.add(this.windowPlaneMesh);

    this.windowPlaneMesh2 = new Mesh(
        new PlaneGeometry(5.8, 2.3),
        new MeshBasicMaterial({color: 'white', side: DoubleSide})
    );
    this.windowPlaneMesh2.position.set(-22.9, 1.6, 0);
    this.windowPlaneMesh2.rotation.y = Math.PI / 2;
    this.windowPlaneMesh2.material.visible = false;
    this.meshOnScene.push(this.windowPlaneMesh2);
    this.scene.add(this.windowPlaneMesh2);

    // RENDERER
    this.renderer = new WebGLRenderer({ antialias: true, alpha: true });
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.toneMapping = ReinhardToneMapping;
    // this.renderer.toneMapping = LinearToneMapping;
    this.renderer.toneMappingExposure = 1;
    this.renderer.setSize(
      this.container.offsetWidth,
      this.container.offsetHeight
    );
    // ADD ON SCENE
    this.container.appendChild(this.renderer.domElement);
    // RESIZE EVENT
    window.addEventListener("resize", this.onWindowResize.bind(this));
    //LIGHT
    this.light();

    var isiPad = navigator.userAgent.match(/iPad/i) != null;
    console.log(isiPad);

    let detect = new MobileDetect(window.navigator.userAgent)
    // console.log("Phone/Tablet: " + detect.mobile());       // телефон или планшет
    // console.log("Phone: " + detect.phone());         // телефон
    // console.log("Tablet: " + detect.tablet());       // планшет
    // console.log("OS: " + detect.os());               // операционная система
    // console.log("userAgent: " + detect.userAgent()); // userAgent

    function isAppleMobile() {
      if (!navigator.userAgent.includes('Apple')) return false;
      try {document.createEvent("TouchEvent");
        return true;
      }
      catch(e){
        return false;
      }
    }

    // alert(navigator.userAgent + isAppleMobile() + detect.mobile());

    // alert(window.navigator.userAgent);
    if (detect.mobile()) {
      this.mobile = true;
      this.control = new Orbit(this);
      this.firstLogIn = true;
    } else {
      if (isAppleMobile()) {
        this.mobile = true;
        this.control = new Orbit(this);
        this.firstLogIn = true;
      } else {
        this.control = new PointerLock(this);
      }
    }

    this.leftPressed = false;
    this.rightPressed = false;
    this.upPressed = false;
    this.downPressed = false;

    this.animate();
  }
  initOrientation() {
    if (this.mobile) {
      const mql = window.matchMedia("(orientation: portrait)");
      if (mql.matches) {
      } else {
        this.orientationBlock.classList.remove('none')
      }
      window.addEventListener('orientationchange', () => {
        if (!this.musIn) {
          if(window.orientation === 0) {
            this.orientationBlock.classList.add('none')
          }
          else {
            this.orientationBlock.classList.remove('none')
          }
        }
      });
    }
  }
  initClickListeners() {
    this.upBtn.addEventListener('touchstart', (e) => {
      e.preventDefault()
      this.upPressed = true;
    })
    this.upBtn.addEventListener('touchend', () => {
      this.upPressed = false;
    })
    this.leftBtn.addEventListener('touchstart', (e) => {
      e.preventDefault()
      this.leftPressed = true;
    })
    this.leftBtn.addEventListener('touchend', () => {
      this.leftPressed = false;
    })
    this.rightBtn.addEventListener('touchstart', (e) => {
      e.preventDefault()
      this.rightPressed = true;
    })
    this.rightBtn.addEventListener('touchend', () => {
      this.rightPressed = false;
    })
    this.downBtn.addEventListener('touchstart', (e) => {
      e.preventDefault()
      this.downPressed = true;
    })
    this.downBtn.addEventListener('touchend', () => {
      this.downPressed = false;
    })

    var lastTouchEnd = 0;
    document.addEventListener('touchend', function (event) {
      var now = (new Date()).getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    }, false);

    // document.getElementById('linkBtn').addEventListener('click', () => {
    //   window.open('https://www.izkor.gov.il/%D7%9E%D7%AA%D7%9F%20%D7%91%D7%A1%D7%A7%D7%99%D7%A0%D7%93/en_70b564ff7113e20717676b590d16291e')
    // })

    document.getElementById('closeBtn').addEventListener('click', () => {
      this.tutorial.classList.add('none');
      this.tutorialSwitch = false;
    })
    document.getElementById('closeBtnMob').addEventListener('click', () => {
      this.tutorialMob.classList.add('none');
      this.tutorialSwitch = false;
    })

    document.getElementById('centralBtn').addEventListener('click', () => {
      if (this.loader === false) {
        this.sound.play();
      }
      this.musIn = true;
      if (this.tutorialSwitch) {
        if (this.mobile) {
          this.tutorialMob.classList.remove('none');
        } else {
          this.tutorial.classList.remove('none');
        }
      } else {
        if (this.mobile) {
          this.tutorialMob.classList.add('none');
        } else {
          this.tutorial.classList.add('none');
        }
      }

      if (this.loader === false) {
        setTimeout(() => {
          if (this.mobile) {
            this.tutorialMob.classList.add('none');
          } else {
            this.tutorial.classList.add('none');
          }
          this.tutorialSwitch = false;
        }, 40000)
      }
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 100)
      this.optionWrap.classList.remove('dispNone');
      if (this.loader === true) {
        document.getElementById('loaderWrap').classList.remove('none');
      }
    })

    document.getElementById('moveBtn').addEventListener('click', (e) => {
      e.preventDefault();
    })
    document.getElementById('moveBtnSecWrap').addEventListener('click', (e) => {
      e.preventDefault();
    })
    document.getElementById('firstBtn').addEventListener('click', (e) => {
      e.preventDefault();
    })
    document.getElementById('secondBtn').addEventListener('click', (e) => {
      e.preventDefault();
    })

    // document.getElementById('painting__close').addEventListener('click', () => {
    //   console.log('fff')
    //   if (!document.getElementById("popup-painting").classList.contains('active')) {
    //     document.getElementById("mainOptWrap").classList.remove("none");
    //   }
    // })

    document.getElementById('exit').addEventListener('click', () => {
      this.sound.pause();
      this.initOrientation();
      this.musIn = false;
      this.tutorial.classList.add('none');
      this.tutorialMob.classList.add('none');
      this.mobJoystick.classList.add('none');
      this.main.classList.remove("none");
      this.optionWrap.classList.add('dispNone');
    })

    document.getElementById('musicIcon').addEventListener('click', () => {
      if (this.volume) {
        Howler.volume(0);
        this.volume = false;
        this.volumeOn.classList.add('dispNone')
        this.volumeOff.classList.remove('dispNone')
      } else {
        Howler.volume(0.3);
        this.volume = true;
        this.volumeOn.classList.remove('dispNone')
        this.volumeOff.classList.add('dispNone')
      }
    })
    document.getElementById('zoomIn').addEventListener('click', () => {
      if (this.image.offsetWidth < 1500) {
        const wdth = this.image.offsetWidth + 50;
        const hght = this.image.offsetHeight + 50;
        const change = wdth.toString();
        const changeH = hght.toString();
        this.image.style.width = change + 'px';
        this.image.style.height = changeH + 'px';
        this.image.style.maxWidth = change + 'px';
        this.image.style.maxHeight = changeH + 'px';
      }
    })
    document.getElementById('zoomOut').addEventListener('click', () => {
      if (this.image.offsetWidth > 190) {
        const wdth = this.image.offsetWidth - 50;
        const hght = this.image.offsetHeight - 50;
        const change = wdth.toString()
        const changeH = hght.toString();
        this.image.style.width = change + 'px';
        this.image.style.height = changeH + 'px';
      }
    })
    document.getElementById('share').addEventListener('click', () => {
      const text = document.getElementById("link").value;
      navigator.clipboard.writeText(text);
      document.getElementById('copyPopUp').classList.remove('none');
      document.getElementById('copyPopUp').classList.remove('hide');
      setTimeout(() => {
        document.getElementById('copyPopUp').classList.add('hide');
      },700)
    })
    document.getElementById('plugin').addEventListener('click', () => {
      this.helpers = document.getElementById('helpers');
      if (this.helpers.classList.contains('none')) {
        this.helpers.classList.remove('none');
      } else {
        this.helpers.classList.add('none');
      }
    })
  }

  light() {
    const light = new HemisphereLight( 0xffffff, 0xffffff, 2.2 );
    light.position.set(0, 7.960, -1.6)
    scene.add( light );

    let dirLight2 = new DirectionalLight(0xffffff, 0.3);
    dirLight2.position.set(9.899, 10, 8.1);
    this.scene.add(dirLight2);

    let dirLight5 = new DirectionalLight(0xffffff, 0.3);
    dirLight5.position.set(-23.184, -11.320, -17.990);
    this.scene.add(dirLight5);

  }

  onWindowResize() {
    this.camera.aspect =
      this.container.offsetWidth / this.container.offsetHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(
      this.container.offsetWidth,
      this.container.offsetHeight
    );
  }

  animate() {
    requestAnimationFrame(() => {
      this.animate();
    });
    if (this.mobile && this.firstLogIn === true) {
      this.firstLogIn = false;
      this.control.orbit.maxAzimuthAngle = 1.5970000000000023;
      this.control.orbit.minAzimuthAngle = 1.5850000000000025;
      this.control.orbit.update();
    } else if (this.leftPressed) {
      let valueAz = this.control.orbit.getAzimuthalAngle() + 0.05;
      this.control.orbit.maxAzimuthAngle = valueAz + 0.001;
      this.control.orbit.minAzimuthAngle = valueAz - 0.001;
      this.control.orbit.update();
      this.control.orbit.maxAzimuthAngle = Infinity;
      this.control.orbit.minAzimuthAngle = -Infinity;
    } else if (this.rightPressed) {
      let valueAz = this.control.orbit.getAzimuthalAngle() - 0.05;
      this.control.orbit.maxAzimuthAngle = valueAz + 0.001;
      this.control.orbit.minAzimuthAngle = valueAz - 0.001;
      this.control.orbit.update();
      this.control.orbit.maxAzimuthAngle = Infinity;
      this.control.orbit.minAzimuthAngle = -Infinity;
    } else if (this.upPressed) {
      let valueAz = this.control.orbit.getPolarAngle() + 0.05;
      this.control.orbit.maxPolarAngle = valueAz + 0.001;
      this.control.orbit.minPolarAngle = valueAz - 0.001;
      this.control.orbit.update();
      this.control.orbit.maxPolarAngle = Infinity;
      this.control.orbit.minPolarAngle = -Infinity;
    } else if (this.downPressed) {
      let valueAz = this.control.orbit.getPolarAngle() - 0.05;
      this.control.orbit.maxPolarAngle = valueAz + 0.001;
      this.control.orbit.minPolarAngle = valueAz - 0.001;
      this.control.orbit.update();
      this.control.orbit.maxPolarAngle = Infinity;
      this.control.orbit.minPolarAngle = -Infinity;
    }
    if (!this.mobile) {
      this.control.motion();
    } else {
      this.control.updatePlayer();
    }
    TWEEN.update();
    this.renderer.render(this.scene, this.camera);
  }
}
